<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.25 10.5V8.75H5.5V7.25H7.25V5.5L8.75 5.5V7.25H10.5V8.75H8.75V10.5L7.25 10.5ZM3.5 8.75V7.25H1V8.75H3.5ZM7.25 3.5L8.75 3.5V1H7.25V3.5ZM12.5 7.25V8.75H15V7.25H12.5ZM8.75 12.5L7.25 12.5V15H8.75V12.5Z" fill="currentColor"/>
</svg>
